import React from 'react';
import { PropTypes } from 'prop-types';
import { FlexRow, FlexCol, TextBlock, Text, Stack } from 'sarsaparilla';
import { formatCurrency, issuanceStatuses } from 'ui-permit/src/utils/utils';
import * as types from 'ui-permit/src/constants';

import { calculateFeesInyoLI } from '../../utils/inyoUtils';

const propTypes = {
  groupMembers: PropTypes.arrayOf(PropTypes.object).isRequired,
  fees: PropTypes.array.isRequired,
  // issuanceStatus: PropTypes.number.isRequired,
  permitType: PropTypes.string,
  isVisitingMtWhitney: PropTypes.bool,
  permitId: PropTypes.string,
  amountPaid: PropTypes.number,
  lineItems: PropTypes.arrayOf(
    PropTypes.shape({
      Description: PropTypes.string,
      FeeType: PropTypes.number,
      Quantity: PropTypes.number,
      Sku: PropTypes.string,
      UnitPrice: PropTypes.number
  }))
};

const defaultProps = {
  groupMembers: [],
  fees: [],
  issuanceStatus: issuanceStatuses.get(types.PERMIT_IN_PROGRESS),
  isVisitingMtWhitney: false,
  permitId: '',
  amountPaid: 0,
  lineItems: []
};

export default class FeeEstimate extends React.Component {
  renderThreeColumnFee(col1, col2, col3) {
    return (
        <FlexRow>
          <FlexCol xs={5} sm={12} lg={5}>{col1}</FlexCol>
          <FlexCol xs={4} sm={6} lg={4}>{col2}</FlexCol>
          <FlexCol xs={3} sm={6} lg={3}>
            <TextBlock textAlign="right">{col3}</TextBlock>
          </FlexCol>
        </FlexRow>
    );
  }

  render() {
    const { groupMembers, lineItems } = this.props;
    const feesMap = calculateFeesInyoLI(lineItems, groupMembers.length);
    if (feesMap.total) {
        if (this.issuanceStatus !== issuanceStatuses.get(types.PERMIT_IN_PROGRESS) &&
            this.issuanceStatus !== issuanceStatuses.get(types.PERMIT_PRELIMINARY) &&
            this.props.permitId === '233260') {
                if (feesMap.total < this.props.amountPaid) {
                    feesMap.total = this.props.amountPaid;
                }
        }
      const useFeeBreakdown = `${feesMap[types.USE_FEE].count} x ${formatCurrency(feesMap[types.USE_FEE].amount/feesMap[types.USE_FEE].count)}`;
      const useFeeTotal = formatCurrency(feesMap[types.USE_FEE].amount);

      const reservationFeeBreakdown = `1 x ${formatCurrency(feesMap[types.RESERVATION_FEE].amount)}`;
      const reservationFeeTotal = formatCurrency(feesMap[types.RESERVATION_FEE].amount);

      const nonRefundableBreakdown = "";
      const nonRefundableFeeTotal = (feesMap[types.NONREFUNDABLE_FEE].amount > 0 ) ? formatCurrency(feesMap[types.NONREFUNDABLE_FEE].amount) : null;
      return (
        <Stack>
          {feesMap[types.USE_FEE] && this.renderThreeColumnFee('Adult/Child', useFeeBreakdown, useFeeTotal)}

          {this.renderThreeColumnFee('Reservation Fee', reservationFeeBreakdown, reservationFeeTotal)}
          {nonRefundableFeeTotal && this.renderThreeColumnFee('Non-refundable Use Fee', nonRefundableBreakdown, nonRefundableFeeTotal)}

          <FlexRow>
            <FlexCol>
              <Text size="lg">Amount Due</Text>
            </FlexCol>
            <FlexCol>
              <TextBlock textAlign="right">
                <Text size="lg" fontWeight="bold">
                  {formatCurrency(feesMap.total - this.props.amountPaid)}
                </Text>
              </TextBlock>
            </FlexCol>
          </FlexRow>
        </Stack>
      );
    }
    return <div />;
  }
}

FeeEstimate.propTypes = propTypes;
FeeEstimate.defaultProps = defaultProps;
